import React, { useEffect, useRef } from "react";
import {
  TextContainer,
  Subheading,
  Link,
} from "../styles/components/Global/Text";
import animations from "./Animations";

const LinkHeading = () => {
  const containerRef = useRef(null);
  useEffect(() => {
    animations.parallax(containerRef.current);
  }, []);
  return (
    <TextContainer ref={containerRef} $align="center" $flex>
      <Subheading $textAlign="center" $width="small">
        <Link
          href="https://www.lotuscars.com/eletre?utm_source=editorial23&utm_medium=PARTNERWEBSITE&utm_campaign=ELETRE_NA_Influencer_Q3_23&utm_content=HS-editorial"
          target="_blank"
          $heading
        >
          Lotus
        </Link>
        &nbsp; and digital artist Ksawery Kirklewski unite their talent and
        passions for futurism to craft an immersive experience that shines as
        bright as the city of light itself.
      </Subheading>
    </TextContainer>
  );
};

export default LinkHeading;
